import React, { useState,useEffect } from 'react';
import './payment.css'
import Sidebar from '../../components/Sidebar/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Link,useParams } from 'react-router-dom'

import BackLoader from '../../components/backloader';


import * as Constants from '../../constants';
import TopBar from '../../components/topbar';


function VerifiedDocument() {
    const {refid} = useParams();
    const [filenames, setFilenames] = useState([]);

    const [docs, setDocs] = useState([]);
    const [caseInfo, setCaseInfo]=useState({});
    const [refs, setRefs]=useState([]);
    const [isLoading,setIsLoading]= useState(false);
    const [schedule, setSchedule]= useState({});
    const [alert, setAlert] = useState({open:false})
    const [search, setSearch]= useState('');
    const [currectdoc, setCurrentDoc]=useState({});
    const [previewWindow, setPreviewWindow] = useState(false)
    const [pageIndex, setPageIndex]=useState(0);
    const [upline, setUpline]=useState({});
    const [isTemplate, setIsTemplate] = useState(false);
    const [html, setHtml] =useState('');
    

    useEffect(() => {
        onCurrentDoc();
        Constants.seo({title:'Affidavit/Document Search',metaDescription:'Affidavit/Document Search'});
      }, []);

    const navigate = useNavigate();

    const onCurrentDoc= async()=>{ //doctype=upline always this one
        //for account registration DocumentView
        const url=`${Constants.apiUrl}/gazette/docverify/${refid}`
    
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log('specific document');
            console.log(data);
            if(data.code==0 ){
                setFilenames(data.filenames);
                setUpline(data.upline);
                if(data.upline.templateHtml!=null){
                  setIsTemplate(true);
                  var htmlstr=Constants.b64decode(data.upline.templateHtml);
                  setHtml(htmlstr);
                }
            }else if(data.code==1 ){
              setIsTemplate(true);
              setUpline(data.upline);
              var htmlstr=Constants.b64decode(data.upline.templateHtml);
              setHtml(htmlstr);
              
          }
            else{
                alert(data.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    
    const onDownload= async()=>{ //doctype=upline always this one
        //for account registration DocumentView
        const url=`${Constants.apiUrl}/gazette/downloadfile/${upline.id}`
    
        console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
                'responseType': 'blob'
              },
            });
            
            const data = await resp.blob();
            setIsLoading(false);
            console.log('specific document');
            const blob = new Blob([data], {type: 'application/pdf'});
                const link = document.createElement('a');
                link.download =upline.filename.split('\\')[1];// 'some.pdf';
                link.href = URL.createObjectURL(blob);
                link.click();
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
    const onNextPage=()=>{
        if(pageIndex < filenames.length-1){
            var ipage=pageIndex+1;
            setPageIndex(ipage);
        }else{
            console.log('its not there again '+pageIndex);
        }
    }
    
    const onPrevPage=()=>{
         if(pageIndex > 0){
            var ipage=pageIndex-1;
            setPageIndex(ipage);
        }else{
            console.log('its not there again '+pageIndex);
        }
    }

    const onPrint=()=>{
      window.print();
    }

  return (
    <div className='payment-records'>
       {/*  <Sidebar /> */}
        <div className="body">
           {/* <TopBar title="Home/Payment/Verify Document" /> */}
            <div className="container">
               

              {isTemplate?<div className="doc">
                
                <div className="paper-final-doc" style={{margin:'auto'}}> <div dangerouslySetInnerHTML={{__html: html}}></div></div>
         {/*        <Link to={`/templates/${template.type}/${id}/edit`}><button className='red'>Switch to edit mode</button></Link> */}
         <button className='red no-print'  style={{margin:'auto'}} onClick={onPrint} >Print/Save Document</button>
         
            </div>
            :
            <div style={{width:'80%', borderColor:'black', borderStyle:'solid'}} >
                <div className="heading">
                    <h2>Preview </h2>
                    <span>Pages <strong>{pageIndex+1 }</strong></span>
                </div>
               
                {filenames.length>0 && <img src={Constants.AbsoluteFiletoRelative(filenames[pageIndex])} style={{width:'100%', margin:0}} />} 
                <div>{filenames.length>1 && <>
                <strong>{pageIndex+1 } / {filenames.length}</strong> 
        
        <button onClick={onPrevPage} className='planred'>Previous Page</button> 
        <button  onClick={onNextPage} type='button' className='planred'>Next Page</button>
                </>}  <button className="planred" onClick={onDownload}>Download</button></div>
                <div className="date-btns">
                    
                  
                </div>
            </div>}  

            </div>
            
            <BackLoader open={isLoading}  />
        </div>
    </div>
  )
}

export default VerifiedDocument